import { useEffect, useState } from 'react';
import { useContent } from '../ContentContext';
import { MetaApi } from '../api';

// Brand splash on first load of the session. If the admin has uploaded splash
// media for the website we show that; otherwise the built-in Golden Taj splash.
export default function Splash({ onDone }) {
  const { company } = useContent();
  const [leaving, setLeaving] = useState(false);
  const [splash, setSplash] = useState(null);
  const [ready, setReady] = useState(false);

  // Fetch the config first so we don't flash the default before the custom one.
  useEffect(() => {
    let alive = true;
    MetaApi.config()
      .then((d) => { if (alive) setSplash(d.splash || null); })
      .catch(() => {})
      .finally(() => { if (alive) setReady(true); });
    return () => { alive = false; };
  }, []);

  useEffect(() => {
    if (!ready) return undefined;
    const hold = splash?.duration || 2000;
    const t1 = setTimeout(() => setLeaving(true), Math.max(hold - 500, 300));
    const t2 = setTimeout(onDone, hold);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [ready, splash, onDone]);

  const media = splash?.web;
  const custom = media?.url ? media : null;

  return (
    <div className={`splash ${leaving ? 'leaving' : ''} ${custom ? 'custom' : ''}`}>
      {custom ? (
        custom.type === 'video' ? (
          <video
            className="splash-media"
            style={{ objectFit: custom.fit || 'contain' }}
            src={custom.url}
            autoPlay
            muted
            playsInline
            // If the clip is shorter than the hold, freeze on its last frame.
            onEnded={(e) => e.currentTarget.pause()}
          />
        ) : (
          // Covers stills and GIFs alike.
          <img
            className="splash-media"
            style={{ objectFit: custom.fit || 'contain' }}
            src={custom.url}
            alt=""
          />
        )
      ) : (
        <div className="splash-inner">
          {company?.logo ? <img src={company.logo} alt={company.name} /> : null}
          <span className="splash-tag">The Royal Grain</span>
          <div className="splash-bar"><span /></div>
        </div>
      )}
    </div>
  );
}
